var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "is-full-page": _vm.fullPage },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.isUpdating && !_vm.isLoading
        ? _c("div", { staticClass: "ui segment" }, [
            _c("p", { staticClass: "ui red zw compact header" }, [
              _vm._v(_vm._s(_vm.$t("pages.checkout.update.title")))
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("pages.checkout.update.hint_1")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("pages.checkout.update.hint_2")))
              ]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.$t("pages.checkout.update.hint_3")))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isUpdating && !_vm.isLoading
        ? _c("div", { staticClass: "ui segment" }, [
            _c("p", { staticClass: "ui red zw compact header" }, [
              _vm._v(_vm._s(_vm.$t("pages.checkout.general.title")))
            ]),
            _vm._v(" "),
            _c(
              "ul",
              [
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("pages.checkout.general.hint_1")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("pages.checkout.general.hint_2")))
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("pages.checkout.general.hint_3")))
                ]),
                _vm._v(" "),
                _vm.unscheduled
                  ? [
                      _c("li", [
                        _vm._v(_vm._s(_vm.$t("pages.checkout.kamstrup.hint_1")))
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(_vm._s(_vm.$t("pages.checkout.kamstrup.hint_3")))
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "dibs-complete-checkout" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d192053", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d192053","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payment/Checkout.vue
// module id = /hsH
// module chunks = 1